package com.tovtalk.utils.language

import kotlinx.browser.window

actual fun getDeviceLanguageCode(): String {
    val lang = window.navigator.language
    return lang.take(2).lowercase().ifBlank { "en" }
}
